import React from 'react';
import WrappedSequence from './WrappedSequence';
import KineticText from './KineticText';

export default function ResumeProcessingAnimation({ isActive }) {
  if (!isActive) return null;

  const steps = [
    {
      type: 'text',
      duration: 2200,
      bgColor: '#E30048', // Deep Pink/Red
      props: {
        text: "Locating your unfair advantage...",
        preset: "rise",
        className: "text-5xl md:text-7xl font-black text-[#FDFD96] tracking-tight leading-[0.95] text-center px-4 uppercase"
      },
      style: { fontFamily: "'Montserrat', sans-serif" }
    },
    {
      type: 'text',
      duration: 2200,
      bgColor: '#1A1A1A', // Dark
      props: {
        text: "Finding jobs to match your vibe...",
        preset: "wipe",
        className: "text-5xl md:text-7xl font-black text-[#00FF99] tracking-tight leading-[0.95] text-center px-4 uppercase"
      },
      style: { fontFamily: "'Montserrat', sans-serif" }
    },
    {
      type: 'text',
      duration: 2200,
      bgColor: '#4834D4', // Deep Purple/Blue
      props: {
        text: "Curating your dream life...",
        preset: "pop",
        className: "text-5xl md:text-7xl font-black text-[#FF79C6] tracking-tight leading-[0.95] text-center px-4 uppercase"
      },
      style: { fontFamily: "'Montserrat', sans-serif" }
    },
    {
      type: 'slide',
      duration: 2800,
      props: {
        direction: 'up',
        bgGradient: 'linear-gradient(to bottom right, #667eea, #764ba2)'
      },
      content: (
        <div className="flex flex-col items-center justify-center h-full w-full px-4">
          <KineticText
            text="Our intern is reviewing your docs..."
            preset="slideUp"
            className="text-5xl md:text-7xl font-black text-white mb-6 tracking-tight leading-[0.95] text-center uppercase"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          />
          <p className="text-lg md:text-xl text-white/80 text-center max-w-lg" style={{ fontFamily: "'Inter', sans-serif" }}>
            They'll ask a few questions to build your personalized roadmap
          </p>
        </div>
      )
    },
    {
      type: 'slide',
      duration: 2200,
      props: {
        direction: 'up',
        bgGradient: 'linear-gradient(to bottom right, #F093FB, #F5576C)'
      },
      content: (
        <div className="flex flex-col items-center justify-center h-full w-full px-4">
          <KineticText
            text="Almost there..."
            preset="slideUp"
            className="text-5xl md:text-7xl font-black text-white mb-8 tracking-tight leading-[0.95] text-center uppercase"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          />
          <div className="w-20 h-20 border-4 border-white/30 border-t-white rounded-full animate-spin" />
        </div>
      )
    }
  ];

  return (
    <WrappedSequence
      steps={steps}
      loop={true}
    />
  );
}
